import { AuthData } from '@core/models/auth-data';
import { Auth } from '@core/models/auth.model';
import { PortalMemberProfile } from '@core/models/portal-member-profile.model';
import { createAction, props } from '@ngrx/store';

export const login = createAction('[Login Page] User Login', props<Auth>());
export const changeProfile = createAction('[Profile Page] Update Profile', props<{ profile: PortalMemberProfile | AuthData }>());
export const register = createAction('[Login Page] User Signup');
export const logout = createAction('[Top Menu] Logout');
